import React from 'react';
import { motion } from 'framer-motion';
import { Scale, AlertCircle, TrendingDown } from 'lucide-react';
export function CostTable() {
  const rows = [{
    without: '100+ horas/año buscando info suelta en internet',
    cost: '10 min/día. El resto es aplicar el protocolo'
  }, {
    without: 'Técnicas sueltas sin secuencia = mismo problema por meses',
    cost: '21 días modelo con criterios exactos de avance → progreso real'
  }, {
    without: '60% de los perros no mejoran sin protocolo',
    cost: 'Sistema de rutina y ESA → calma consolidada'
  }, {
    without: 'Notas del consorcio sin saber qué decir',
    cost: 'Protocolo vecino amigable + resultados visibles en 14 días'
  }, {
    without: 'Destrozos y ladridos cada vez que salís',
    cost: 'Protocolo de Salida Invisible → perro calmo solo'
  }, {
    without: 'Culpa constante de dejarlo solo',
    cost: 'Protocolo aplicado con confianza = sin culpa'
  }, {
    without: 'Adiestrador particular $15.000-$40.000 por sesión',
    cost: '30 min/día de protocolo = resultados sin gasto mensual recurrente'
  }, {
    without: 'El mismo problema que el año que viene',
    cost: 'Sistema de 21 días genera cambio real y duradero'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-91">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-92">
        <div className="text-center mb-10" data-id="element-93">
          <div className="inline-flex items-center justify-center p-3 bg-navy-800 rounded-full mb-4 border border-navy-600" data-id="element-94">
            <Scale className="w-8 h-8 text-gold-400" data-id="element-95" />
          </div>
          <p className="text-gold-400 font-bold tracking-wider uppercase text-sm mb-2" data-id="element-96">
            🐾 MUNDORECURSOS™
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-97">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="overflow-hidden rounded-2xl border border-red-900/30 bg-navy-900/80 shadow-2xl" data-id="element-98">
          <table className="w-full text-left border-collapse" data-id="element-99">
            <thead data-id="element-100">
              <tr data-id="element-101">
                <th className="p-4 md:p-6 border-b border-navy-700 bg-navy-800 text-gray-300 font-semibold w-1/2" data-id="element-102">
                  <div className="flex items-center gap-2" data-id="element-103">
                    <AlertCircle className="w-4 h-4 text-gray-400" data-id="element-104" />
                    Sin Guía Del Perro Tranquilo
                  </div>
                </th>
                <th className="p-4 md:p-6 border-b border-green-900/50 bg-green-950/20 text-green-400 font-bold w-1/2" data-id="element-105">
                  <div className="flex items-center gap-2" data-id="element-106">
                    <TrendingDown className="w-4 h-4 text-green-400" data-id="element-107" />
                    Con Guía Del Perro Tranquilo
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-108">
              {rows.map((row, index) => <tr key={index} className="border-b border-navy-800 last:border-0" data-id="element-109">
                  <td className="p-4 md:p-6 text-red-200/70" data-id="element-110">{row.without}</td>
                  <td className="p-4 md:p-6 text-green-200/90 font-medium bg-green-950/10" data-id="element-111">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </section>;
}